import { AxiosInstance } from 'axios';
import { CommentsRepository } from '@/model/repository/manager/comments/CommentsRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): CommentsRepository => ({
    index(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
  });
